import { FETCH_QUERIES_NAME, MUTATION_KEYS } from '@common/constants';
import { AxiosErrorResponse } from '@core/error.models';
import { useMutation, useQuery } from '@tanstack/react-query';
import { IItemResponse } from '@gcl/react-core';
import { getMyGemsAsync, postMyGemsAsync, putMyGemsAsync } from './myGems.services';
import { ICreateMyGemsRequest, IGetMyGemsRequest, IMyGems, IUpdateMyGemsRequest } from './myGems.models';

export const useGetMyGems = (props: IGetMyGemsRequest, enabled = true) => {
  return useQuery<IMyGems[], AxiosErrorResponse>(
    [FETCH_QUERIES_NAME.MY_GEMS, props.shouldIncludeInactive],
    async () => {
      const result = await getMyGemsAsync(props);
      return result.items || [];
    },
    { enabled },
  );
};

export const useCreateMyGems = () => {
  return useMutation<IItemResponse<IMyGems>, AxiosErrorResponse, ICreateMyGemsRequest>(
    [MUTATION_KEYS.CREATE_MY_GEMS],
    async (request: ICreateMyGemsRequest) => {
      const result = await postMyGemsAsync(request);
      return result;
    },
  );
};

export const useUpdateMyGems = () => {
  return useMutation<IItemResponse<IMyGems>, AxiosErrorResponse, IUpdateMyGemsRequest>(
    [MUTATION_KEYS.UPDATE_MY_GEMS],
    async (request: IUpdateMyGemsRequest) => {
      const result = await putMyGemsAsync(request.id, request);
      return result;
    },
  );
};
